import { ShopUxBannerLinkType } from '@domains/storehome-common';

interface Params {
  link?: string;
  link_type: ShopUxBannerLinkType | null;
  shop_main_domain: string | string[] | undefined;
}

export const convertBannerLink = ({
  link,
  link_type,
  shop_main_domain,
}: Params): { link: string | null; is_legacy?: boolean } => {
  if (!link) {
    return { link: null };
  }

  // 스토어픽으로 이동
  if (link_type === null) {
    const match = /store-pick\/detail\?id=(\d+(?:,\d+)+)/.exec(link);
    if (match && match[1]) {
      const store_pick_url = `/store-pick/detail?id=${match[1]}`;
      return { link: store_pick_url, is_legacy: false };
    }
    // TODO: BE 링크 변경 이후 제거
    const match_legacy = /.+url=(.+)/.exec(link);
    if (match_legacy) {
      const store_pick_url = match_legacy[1];
      if (store_pick_url) {
        return { link: store_pick_url, is_legacy: true };
      }
    }
    return { link: null };
  }

  // PDP로 이동
  if (link_type === ShopUxBannerLinkType.PRODUCT) {
    const match = /.+url=.+products\/(\w+)/.exec(link);
    if (match && match[1]) {
      const catalog_product_url = `/catalog/products/${match[1]}`;
      return { link: catalog_product_url };
    }
  }

  // 스토어홈 카테고리 상세 화면으로 이동
  if (link_type === ShopUxBannerLinkType.CATEGORY) {
    const match = /.+category_id=(\w+)/.exec(link);
    if (match && match[1]) {
      const category_url = `/${shop_main_domain}/category/${match[1]}`;
      return { link: category_url };
    }
  }

  // 스토어홈 카테고리 상세 화면으로 이동
  if (link_type === ShopUxBannerLinkType.COLLECTION) {
    const match = /.+collection\/(\w+)/.exec(link);
    if (match && match[1]) {
      const collection_url = `/${shop_main_domain}/collection/${match[1]}`;
      return { link: collection_url };
    }
  }

  return { link: null };
};
